const ExamSchedule = () => {
    return (
        <div id="exam" className="vision-card">
            <h3>EXAM SCHEDULE</h3>

            <p>Periodic Test - July</p>
            <p>Half Yearly Exam - September</p>
            <p>Annual Exam - February / March</p>
        </div>
    );
};

export default ExamSchedule;